<template>
  <transition
    v-on:enter="enter"
    v-on:leave="leave"
    v-bind:css="false"
    appear>
    <div class="page-slide-transition" :class="theme">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
import { TimelineMax, TweenMax, Power4 } from 'gsap';

export default {
  name: 'slide-transition',
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    enter(el, done) {
      const tl = new TimelineMax({
        onComplete: done,
      });

      tl.set(el, {
        x: el.offsetWidth,
      });

      tl.to(el, 1, {
        x: 0,
        ease: Power4.easeOut,
      });
    },
    leave(el, done) {
      TweenMax.fromTo(el, 1,
        {
          autoAlpha: 1,
        },
        {
          autoAlpha: 0,
          x: el.offsetWidth,
          ease: Power4.easeOut,
          onComplete: done,
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-slide-transition {
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    // width: 100vw;
    height: 100vh;
    position: absolute;
    z-index: 200;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/transitions/slide-transition.vue